// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/item/item-list/item-list.scss
// module id = 524
// module chunks = 0